import { Link } from 'react-router-dom'
import { PHONE_DISPLAY, PHONE_TEL, OFFICE_ADDRESS, SERVICE_AREA, CANADIAN_LINE } from '../lib/constants'

const colHead = {
  fontFamily: 'var(--font-sans)',
  fontWeight: 600,
  fontSize: 15,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'oklch(0.9765 0.0098 87.47 / 70%)',
  margin: 0,
}
const colLinks = { marginTop: 16, display: 'flex', flexDirection: 'column', gap: 12, fontSize: 17 }
const linkStyle = { color: 'oklch(0.9765 0.0098 87.47 / 90%)', textDecoration: 'none' }
const underlined = { ...linkStyle, textDecoration: 'underline', textUnderlineOffset: 4 }

export default function Footer() {
  return (
    <footer
      style={{
        background: 'var(--color-teal-900)',
        color: 'var(--color-cream)',
        fontFamily: 'var(--font-sans)',
        fontSize: 18,
        lineHeight: 1.65,
      }}
    >
      <div className="container-site grid grid-4" style={{ padding: '64px 24px', gap: 48 }}>
        <div>
          <p style={{ fontFamily: 'var(--font-serif)', fontSize: 24, fontWeight: 600, lineHeight: 1.2, margin: 0 }}>
            True North Care &amp; Support
          </p>
          <p style={{ margin: '16px 0 0 0', fontSize: 17, lineHeight: 1.6, color: 'oklch(0.9765 0.0098 87.47 / 85%)' }}>
            Warm, non-medical in-home care for seniors in Calgary — personalized care plans, screened caregivers and
            families kept in the loop.
          </p>
          <p style={{ margin: '16px 0 0 0', fontSize: 17, color: 'oklch(0.9765 0.0098 87.47 / 85%)' }}>{CANADIAN_LINE}</p>
        </div>
        <div>
          <h2 style={colHead}>Services</h2>
          <div style={colLinks}>
            <Link to="/services/personal-care" style={linkStyle}>Personal Care Services</Link>
            <Link to="/services/meals-housekeeping" style={linkStyle}>Meal Preparation &amp; Light Housekeeping</Link>
            <Link to="/services/companionship" style={linkStyle}>Companionship &amp; Outings</Link>
            <Link to="/services/post-hospital-care" style={linkStyle}>Post-Hospital Care</Link>
            <Link to="/specialized-care" style={linkStyle}>Specialized Care</Link>
            <Link to="/client-directed-home-care-invoicing" style={linkStyle}>Client Directed Home Care (CDHCI)</Link>
          </div>
        </div>
        <div>
          <h2 style={colHead}>Company</h2>
          <div style={colLinks}>
            <Link to="/about" style={linkStyle}>About Us</Link>
            <Link to="/how-it-works" style={linkStyle}>How It Works</Link>
            <Link to="/resources" style={linkStyle}>Resources</Link>
            <Link to="/careers" style={linkStyle}>Careers</Link>
            <Link to="/family-room" style={linkStyle}>Family Room</Link>
            <Link to="/schedule-assessment" style={linkStyle}>Schedule an Assessment</Link>
          </div>
        </div>
        <div>
          <h2 style={colHead}>Contact</h2>
          <div style={{ ...colLinks, color: 'oklch(0.9765 0.0098 87.47 / 90%)' }}>
            <a href={PHONE_TEL} style={{ ...linkStyle, fontWeight: 600 }}>{PHONE_DISPLAY}</a>
            <span>{OFFICE_ADDRESS}</span>
            <span>{SERVICE_AREA}</span>
            <Link to="/contact" style={underlined}>Contact Us</Link>
            <Link to="/login" style={underlined}>Portal Login</Link>
          </div>
        </div>
      </div>
      <div style={{ borderTop: '1px solid oklch(0.9765 0.0098 87.47 / 20%)' }}>
        <div
          className="container-site"
          style={{
            padding: 24,
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            fontSize: 16,
            color: 'oklch(0.9765 0.0098 87.47 / 80%)',
          }}
        >
          <p style={{ margin: 0 }}>© 2026 True North Care &amp; Support. Non-medical in-home care.</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
            <Link to="/privacy" style={{ color: 'oklch(0.9765 0.0098 87.47 / 80%)', textDecoration: 'none' }}>Privacy</Link>
            <Link to="/terms" style={{ color: 'oklch(0.9765 0.0098 87.47 / 80%)', textDecoration: 'none' }}>Terms</Link>
            <Link to="/accessibility" style={{ color: 'oklch(0.9765 0.0098 87.47 / 80%)', textDecoration: 'none' }}>Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
